@if (!isWistiaUrl()) {
  <iframe sandbox="allow-scripts allow-same-origin" class="video-player-iframe"
  [src]="videoSrc() | safeUrl" frameborder="0" [height]="height" [width]="width" allowfullscreen></iframe>
}

@if (isWistiaUrl()) {
  <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
    <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
      <div [ngClass]="getWistiaVideoClasses()" style="height:100%;position:relative;width:100%">&nbsp;</div>
    </div>
  </div>
}
@if (showUrl) {
  <div class='video-url'>{{videoUrl}}</div>
}
